// Route paths that render the auth flow. The desktop modal only opens when the
// navigation carries `state.backgroundLocation` (set by explicit Log In / Sign Up
// buttons); system redirects and deep links land on the standalone page instead.
export const AUTH_PATHS = ['/connect', '/sign-up']

export const AUTH_SCREENS = {
    LOGIN: 'login',
    SIGNUP: 'signup',
    VERIFY_EMAIL: 'verify-email',
    OTP: 'otp',
    RESET_REQUEST: 'reset-request',
    RESET_KEY: 'reset-key',
    RESET_NEW_PASSWORD: 'reset-new-password',
}
